/** Determine whether a screenshot is being taken. */
// LATER: Remove and use Storycap equivalent when Storybook 9 compatible version is available: https://gitlab.com/sparksuite-family/sparksuite/spark/-/issues/3688
export default function isScreenshot() {
	// Original code: https://github.com/reg-viz/storycap/blob/157669e291c9291ca17208fed1db9f49d98c088e/packages/storycap/src/client/is-screenshot.ts
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	return Boolean((window as any).emitCapture);
}
